export default "__VITE_ASSET__CiOSRbzu__"